import { PlanSubscriptionDetails } from "@models/plan-subscription-details";

export function isActiveTrial(subscription: PlanSubscriptionDetails): boolean {
  return (
    !subscription ||
    !!(
      subscription.isTrial &&
      subscription.expirationDate &&
      new Date(subscription.expirationDate).getTime() > Date.now()
    )
  );
}

export function isExpired(subscription: PlanSubscriptionDetails): boolean {
  return (
    !subscription ||
    !!(
      subscription.expirationDate &&
      new Date(subscription.expirationDate).getTime() <= Date.now()
    )
  );
}

export function isLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return (
    !subscription ||
    !!(
      subscription.remainingLimits &&
      (isPhotosLimitReached(subscription) || isRemindersLimitReached(subscription) || isCallTimeLimitReached(subscription))
    )
  );
}

export function isPhotosLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return subscription.plan.limits.photos >= 0 && subscription.remainingLimits.photos <= 0;
}

export function isRemindersLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return subscription.plan.limits.reminders >= 0 && subscription.remainingLimits.reminders <= 0;
}

export function isCallTimeLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return subscription.plan.limits.talkSeconds >= 0 && subscription.remainingLimits.talkSeconds <= 0;
}
